import CardBanner from "@/components/CardBanner.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { builderCta } from "@/helpers/builder-init/index";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
const colors = ["None", ...Object.keys(themeColors)];
const { hasValue, hasValueEqualTo, hasRichText } = useBuilderShowIf();
export const cardBannerInit = {
    component: CardBanner,
    name: "CardBanner",
    inputs: [
        {
            name: "banner",
            friendlyName: "Banner",
            type: "object",
            subFields: [
                {
                    name: "eyebrow",
                    friendlyName: "Eyebrow",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            friendlyName: "Text",
                            type: "string",
                        },
                        {
                            name: "color",
                            friendlyName: "Color",
                            type: "string",
                            enum: colors,
                            showIf: hasValue("text")
                        }
                    ]
                },
                {
                    name: "heading",
                    friendlyName: "Heading",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            friendlyName: "Text",
                            type: "string"
                        },
                        {
                            name: "color",
                            friendlyName: "Color",
                            type: "string",
                            enum: colors,
                            showIf: hasValue("text")
                        }
                    ]
                },
                {
                    name: "description",
                    friendlyName: "Description",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            friendlyName: "Text",
                            type: "string"
                        },
                        {
                            name: "color",
                            friendlyName: "Color",
                            type: "string",
                            enum: colors,
                            showIf: hasValue("text")
                        }
                    ]
                },
                {
                    name: "banner_media",
                    friendlyName: "Banner Media",
                    type: "object",
                    subFields: [
                        {
                            name: "desktop_media",
                            friendlyName: "Media for Desktop",
                            helperText:
                                "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
                            allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
                            type: "file"
                        },
                        {
                            name: "mobile_media",
                            friendlyName: "Media for Mobile",
                            helperText:
                                "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
                            allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
                            type: "file"
                        },
                        {
                            name: "min_height",
                            friendlyName: "Min Banner Height (px)",
                            helperText: "",
                            type: "number"
                        },
                        {
                            name: "max_height",
                            friendlyName: "Max Banner Height (px)",
                            helperText: "",
                            type: "number"
                        },
                    ]
                }
            ]
        },
        {
            name: "cards",
            friendlyName: "Cards",
            type: "list",
            subFields: [
                {
                    name: "title",
                    friendlyName: "Card Title",
                    type: "string",
                },
                {
                    name: "image",
                    friendlyName: "Card Image",
                    helperText:
                        "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
                    allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
                    type: "file"
                },
            ],
        }
    ]
}